// access
import {
  accessVersarOnly,
  accessVersarAndSchoolAdmin,
  accessContentCreate,
  accessContents,
  accessClassrooms,
  accessSettingsClassrooms,
  accessSettings,
  accessRooms,
  accessMessagesBase,
  accessMessagesInbox,
  accessAnnouncements,
  accessReports,
  accessReportCreate,
  accessReportStudentDetail,
  accessMaterials,
  accessPickup,
  roles,
  accessAnnouncementsCreate
} from '../utils/constants'

export const socioemotionalPaths = [
  {
    path: '/modules',
    permission: accessContentCreate
  },
  {
    path: '/socioemotional',
    permission: accessContentCreate
  },
  {
    path: '/newmodules',
    permission: accessContentCreate
  },
  {
    path: '/newmodules/create',
    permission: accessContentCreate,
    componentAttribute: {
      isCreate: true
    }
  },
  {
    path: '/newmodules/:moduleId/edit',
    permission: accessContentCreate,
    componentAttribute: {
      isEdit: true
    }
  },
  {
    path: `/newmodules/:moduleId/themes/create`,
    permission: accessContentCreate,
    componentAttribute: {
      isCreate: true
    }
  },
  {
    path: '/newthemes',
    permission: accessContentCreate
  },
  {
    path: `/newthemes/create`,
    permission: accessContentCreate,
    componentAttribute: {
      isCreate: true
    }
  },
  {
    path: `/newthemes/:themeId/contents`,
    permission: accessContentCreate,
    componentAttribute: {
      stepTwo: true
    }
  },
  {
    path: `/newthemes/:themeId/preview`,
    permission: accessContentCreate,
    componentAttribute: {
      stepThree: true
    }
  },
  {
    path: `/newthemes/:themeId/edit`,
    permission: accessContentCreate,
    componentAttribute: {
      isEdit: true
    }
  },
  {
    path: `/newcontents/:themeId/create`,
    permission: accessContentCreate,
    componentAttribute: {
      isCreate: true
    }
  },
  {
    path: `/newcontents/:themeId/edit/:contentId`,
    permission: accessContentCreate,
    componentAttribute: {
      isEdit: true
    }
  },
  {
    path: '/modules/create',
    permission: accessContentCreate
  },
  {
    path: '/modules/:id',
    permission: accessContentCreate
  },
  {
    path: '/modules/:id/edit',
    permission: accessContentCreate
  },
  {
    path: '/themes',
    permission: accessContentCreate
  },
  {
    path: '/themes/create',
    permission: accessContentCreate
  },
  {
    path: '/themes/:id/edit',
    permission: accessContentCreate
  },
  {
    path: '/themes/:id',
    permission: accessContents
  },
  {
    path: '/contents',
    permission: accessContentCreate
  },
  {
    path: '/contents/create',
    permission: accessContentCreate
  },
  {
    path: '/contents/:id',
    permission: accessContents
  },
  {
    path: '/contents/:id/edit',
    permission: accessContentCreate
  },
  {
    path: '/classrooms',
    permission: accessClassrooms
  },
  {
    path: '/classrooms/:id',
    permission: accessClassrooms
  },
  {
    path: '/planning/grades',
    permission: accessVersarOnly
  },
  {
    path: '/planning/grades/:gradeId',
    permission: accessVersarOnly
  },
  {
    path: '/planning/grades/:gradeId/search',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/theme-schedule/grades',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/theme-schedule/schools',
    permission: accessVersarOnly
  },
  {
    path: '/theme-schedule/schools/:schoolId/grades',
    permission: accessVersarOnly
  },
  {
    path: '/theme-schedule/schools/:schoolId/grades/:gradeId',
    permission: accessVersarOnly
  },
  {
    path: '/theme-schedule/grades/:gradeId',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/theme-schedule/schools/:schoolId/grades/:gradeId/:templateId',
    permission: accessVersarOnly
  },
  {
    path: '/theme-schedule/grades/:gradeId/:templateId',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path:
      '/theme-schedule/schools/:schoolId/grades/:gradeId/:templateId/search',
    permission: accessVersarOnly
  },
  {
    path: '/theme-schedule/grades/:gradeId/:templateId/search',
    permission: accessVersarAndSchoolAdmin
  }
]

export const settingsPaths = [
  {
    path: '/settings',
    permission: accessSettings,
    defaultFor: [roles.STUDENT, roles.PARENT, roles.NURSE, roles.PSYCHOLOGIST]
  },
  {
    path: '/settings/delete_profile',
    permission: accessSettings
  },
  {
    path: '/settings/covers',
    permission: accessVersarOnly
  },
  {
    path: '/settings/classrooms',
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/classrooms/new',
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/classrooms/:classId',
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/classrooms/:classId/edit',
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/classrooms/:classId/students/new',
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/classrooms/:classId/students/:childId',
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/teachers',
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/teachers/new',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/teachers/reactivate',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/teachers/:teacherId/edit',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/coordinator',
    permission: accessSettingsClassrooms
  },
  {
    path: '/settings/coordinator/new',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/coordinator/:coordinatorId/edit',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/coordinator/reactivate',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/moderation',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/layout',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/historic',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/doorman',
    permission: accessVersarAndSchoolAdmin
  },
  {
    path: '/settings/doorman/create',
    permission: accessVersarAndSchoolAdmin,
    componentAttribute: {
      default_occupation: 14
    }
  },
  {
    path: '/settings/doorman/:id',
    permission: accessVersarAndSchoolAdmin,
    componentAttribute: {
      default_occupation: 14,
      is_edit: true
    }
  }
]
export const messagesPaths = [
  {
    path: '/rooms/:chatId?',
    permission: accessRooms
  },
  {
    path: '/messages',
    permission: accessMessagesBase
  },
  {
    path: '/messages/schools',
    permission: accessVersarOnly
  },
  {
    path: '/messages/inbox',
    permission: accessMessagesBase
  },
  {
    path: '/messages/schools/:schoolId/inbox',
    permission: accessVersarOnly
  },
  {
    path: '/messages/schools/:schoolId',
    permission: accessVersarOnly
  },
  {
    path: '/messages/inbox/:communicationId',
    permission: accessMessagesInbox
  },
  {
    path: '/messages/schools/:schoolId/inbox/:communicationId',
    permission: accessVersarOnly
  },
  {
    path: '/messages/create',
    permission: accessMessagesBase
  },
  {
    path: '/messages/schools/:schoolId/create',
    permission: accessVersarOnly
  }
]

export const announcementsPaths = [
  {
    path: '/announcements',
    permission: accessAnnouncements,
    defaultFor: [roles.VERSAR_ADMIN]
  },
  {
    path: '/announcements/create',
    permission: accessAnnouncementsCreate,
    componentAttribute: {
      isCreate: true
    }
  },
  {
    path: '/announcements/:eventId',
    permission: accessAnnouncements,
    componentAttribute: {
      isView: true
    }
  },
  {
    path: '/announcements/edit/:eventId',
    permission: accessAnnouncementsCreate,
    componentAttribute: {
      isEdit: true
    }
  },
  {
    path: '/announcements/review/:eventId',
    permission: accessAnnouncementsCreate,
    componentAttribute: {
      isReview: true
    }
  },
  {
    path: '/announcements/:eventId/details',
    permission: accessAnnouncements
  },
  {
    path: '/announcements/:eventId/confirmations',
    permission: accessAnnouncements
  }
]

export const reportsPaths = [
  {
    path: '/reports',
    permission: accessReports
  },
  {
    path: '/reports/create',
    permission: accessReportCreate,
    componentAttribute: {
      isCreate: true
    }
  },
  {
    path: '/reports/:reportId/classroom',
    permission: accessReports
  },
  {
    path: '/reports/:reportId/classroom/:reportStudentId',
    permission: accessReports
  },
  {
    path: '/reports/:reportId/classroom/all/students',
    permission: accessReports
  },
  {
    path: '/report_template/:reportTemplateId',
    permission: accessReports
  },
  {
    path: '/report_student/details',
    permission: accessReportStudentDetail
  }
]

export const materialPaths = [
  {
    path: '/materials',
    permission: accessMaterials
  },
  {
    path: '/materials/create',
    permission: accessMaterials,
    componentAttribute: {
      isCreate: true
    }
  },
  {
    path: '/materials/:materialId',
    permission: accessMaterials
  },
  {
    path: '/materials/:materialId/edit',
    permission: accessMaterials,
    componentAttribute: {
      isEdit: true
    }
  },
  {
    path: '/materials/:materialId/report',
    permission: accessMaterials,
    componentAttribute: {
      isReport: true
    }
  }
]

export const pickupPaths = [
  {
    path: '/pickup',
    permission: accessPickup
  },
  {
    path: '/pickup/authorizations',
    permission: accessPickup
  },
  {
    path: '/pickup/authorization/create',
    permission: accessPickup
  },
  {
    path: '/pickup/authorization/:id',
    permission: accessPickup
  },
  {
    path: '/pickup/pending',
    permission: accessPickup
  },
  {
    path: '/pickup/manual',
    permission: accessPickup
  },
  {
    path: '/pickup/today',
    componentAttribute: {
      today: true
    },
    permission: accessPickup
  },
  {
    path: '/pickup/history',
    permission: accessPickup
  }
]
